export default "__VITE_ASSET__Brn_PUyr__"